import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { call } from '@spacefill/shared/src/utils/Backend';
import { safeLocalStorage } from '@spacefill/uikit/src/utils/storage';

export function isOnOrderPage(pathname) {
    if (!pathname) {
        return false;
    }
    const orderPagePatterns = [
        /^\/logistic-management\/orders\/[^/]+\/?$/,
        /^\/logistic-management\/warehouses\/[^/]+\/orders\/[^/]+\/?$/,
        /^\/logistic-management\/warehouses\/[^/]+\/entry-orders\/[^/]+\/?$/,
        /^\/logistic-management\/warehouses\/[^/]+\/exit-orders\/[^/]+\/?$/,
    ];

    return orderPagePatterns.some((pattern) => pattern.test(pathname));
}

export async function handleContextSwitch({
    switchValue = null,
    redirectFromOrderTo = '/',
    setLoading = null,
    currentPathname = null,
    skipRedirectFromOrder = false,
} = {}) {
    try {
        if (switchValue) {
            await call(
                '/users/',
                {},
                'GET',
                switchValue.type === 'CUSTOMER' ? { 'x-customer-id': switchValue.id } : { 'x-lsp-id': switchValue.id }
            );
        } else {
            await call('/users/', {}, 'GET');
        }
        if (setLoading) {
            setLoading(true);
        }
        safeLocalStorage.clear();
        const pathname = currentPathname ?? window.location.pathname;
        if (skipRedirectFromOrder) {
            window.location.reload();
        } else if (isOnOrderPage(pathname)) {
            window.location.href = redirectFromOrderTo;
        } else {
            window.location = '';
        }
    } catch {
        safeLocalStorage.clear();
        window.location = '';
    }
}

export function isReloadPageAndClearStorageError(error) {
    if (!error) {
        return false;
    }
    if (error.details?.status === 'ReloadPageAndClearStorage') {
        return true;
    }
    return false;
}

export function useReloadPageAndClearStorageError(error) {
    const { pathname } = useLocation();
    useEffect(() => {
        if (error && isReloadPageAndClearStorageError(error)) {
            setTimeout(() => {
                handleContextSwitch({
                    currentPathname: pathname,
                    skipRedirectFromOrder: true,
                });
            }, 0);
        }
    }, [error, pathname]);
}
